module.exports = __webpack_public_path__ + "static/media/Stellar Ace King Headboard - 180 cm_Cream.96fad8c8.png";